import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCategoryArticles as fetchCategoryArticlesClient } from '../clients/kb-api.v3';
import Raven from 'raven-js';
export const fetchCategoryArticles = createAsyncThunk('articles/fetchCategoryArticles', ({
  knowledgeBaseId,
  categoryId
}) => {
  return fetchCategoryArticlesClient(knowledgeBaseId, categoryId).then(res => res).catch(error => {
    Raven.captureException(error);
    throw error;
  });
});